<template>
    
    <div class="row mt-4 justify-content-center">
        <input type="hidden" :value="ValidarSubs"/>
        <template v-for="(itemSubmenu,index2) in ListaSubMenus">
            <div v-if="VerificaItemVisible(itemSubmenu.Permiso,itemSubmenu.EsDeRoot)" :key="index2" class="col-12 col-sm-12 col-md-3 col-lg-2">

                <router-link :to="{name: itemSubmenu.Router, params: itemSubmenu.Parametros}" class="d-grid gap-2">
                    <button type="button" class="btn btn-01 btn-sub">
                        <p class="mb-1"><i :class="itemSubmenu.Icono + ' fa-4x'"></i></p>
                        <span>{{itemSubmenu.Nombre}}</span>
                    </button>
                </router-link>
            
            </div>
        </template>
    </div>
   
</template>

<script>

export default {
    name:'SubMenus',
    props:[],
    components:{
    },
    data() {
        return {
            ConfigList: {
                ShowTitleFirst: false,
                Title: "Menús",
                TypeBody: "Form",
                IsModal: false,
                ShowFiltros: false,
                BtnNewShow: false,
                ShowPaginador:  false,
                ShowLoader: false,
            },
            ListaSubMenus: [],
            ListaArrayAsignado: [],
            VerMenuLocal: 0,
        }
    },
    methods: {
        VerificaItemVisible(Clave,EsDeRoot)
        {
            let user = JSON.parse(sessionStorage.getItem("user"));
            
            if(EsDeRoot==1 && parseInt(user.IdPerfil) != 1){
                return false;
            }
        
            let Val = (this.ListaArrayAsignado != undefined) ? this.ListaArrayAsignado.find( item => item.Clave == Clave) : false;
            if(this.VerMenuLocal>0){
                return true;
            }
            if (!Val) return false;
            
            return true;
        },       
    },
    created() {
        this.bus.$off('BusquedaMenus');
    },
    mounted() {
        this.bus.$on('BusquedaMenus',(arr,arr2)=> {
            this.ListaSubMenus = arr;
            this.ListaArrayAsignado = arr2;

            /* console.log('subs')
            console.log(this.ListaSubMenus);
            console.log('asig')
            console.log(this.ListaArrayAsignado); */
        });
    },
    computed: {
        ValidarSubs()
        {
            this.ListaSubMenus = JSON.parse(sessionStorage.getItem('oSubMenus'));
            this.ListaArrayAsignado = JSON.parse(sessionStorage.getItem('oPanelesAsignados'));
            this.VerMenuLocal = sessionStorage.getItem('oAsignadoPrincipal');

            return this.ListaSubMenus;
        }
    }
}
</script>
